import { MimeType } from './MimeType';

export default MimeType;
